var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"van-cell van-field",class:{'van-cell--required':!!_vm.option.required}},[_c('div',{staticClass:"van-cell__title van-field__label"},[_c('span',[_vm._v(_vm._s(_vm.option.label))])]),_vm._v(" "),_c('van-uploader',_vm._b({attrs:{"multiple":""},on:{"oversize":_vm.onOversize},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}},'van-uploader',_vm.option.props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f659ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myUpFile.vue
// module id = 213
// module chunks = 0